import { useEffect, useRef, useState } from "react";

/**
 * useInView: sets a ref-based flag when the element enters the viewport.
 * Fires once by default (freeze=true).
 */
export function useInView({ threshold = 0.2, freeze = true } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setInView(true);
            if (freeze) io.unobserve(el);
          } else if (!freeze) {
            setInView(false);
          }
        });
      },
      { threshold }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold, freeze]);

  return [ref, inView];
}
